import styled from '@emotion/styled';

import { breakpoints } from '~/src/styles';

export const Wrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  ${breakpoints.minMobileLandscape} {
    padding: 60px;
  }
`;

export const FormBody = styled.div`
  display: flex;
  flex-directions: column;
`;
